module.exports = __webpack_public_path__ + "img/WildMe-preview.eedd6e80.jpg";